import { render, staticRenderFns } from "./inform-unread.vue?vue&type=template&id=141ddbd9&scoped=true"
import script from "./inform-unread.vue?vue&type=script&lang=js"
export * from "./inform-unread.vue?vue&type=script&lang=js"
import style0 from "./inform-unread.vue?vue&type=style&index=0&id=141ddbd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141ddbd9",
  null
  
)

export default component.exports